import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { PORTFOLIO_LIST, SITE_URL } from "../common";
import { AboutProject, Seo } from "../components";
import { RouteNames } from "../router";

export const ProjectPage = () => {
  const { id } = useParams();

  const card = PORTFOLIO_LIST.find((item) => String(item.id) === id);

  if (!card) {
    return <Navigate to={RouteNames.NOT_FOUND} replace />;
  }

  const path = `${RouteNames.PORTFOLIO}/${card.id}`;
  const title = `${card.title} Custom Kitchen Project | HomeCraft Masters`;
  const description = `View the ${card.title} custom kitchen and cabinetry project completed in ${card.text} by HomeCraft Masters in Colorado.`;
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ImageGallery",
        "@id": `${SITE_URL}${path}#gallery`,
        name: `${card.title} Custom Kitchen Project`,
        description,
        url: `${SITE_URL}${path}`,
        image: [card.img, ...card.collection.map((item) => item.img)].map(
          (image) => new URL(image, SITE_URL).href
        ),
        creator: {
          "@id": `${SITE_URL}/#business`,
        },
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: SITE_URL,
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Gallery",
            item: `${SITE_URL}${RouteNames.PORTFOLIO}`,
          },
          {
            "@type": "ListItem",
            position: 3,
            name: card.title,
            item: `${SITE_URL}${path}`,
          },
        ],
      },
    ],
  };

  return (
    <>
      <Seo
        title={title}
        description={description}
        path={path}
        image={card.img}
        structuredData={structuredData}
      />
      <div className="container-margin">
        <div className="container">
          <AboutProject card={card} />
        </div>
      </div>
    </>
  );
};
